export default __webpack_public_path__ + "static/media/career-img-3.2980954d.png";